import styled from 'styled-components'

export const ScrollContainer = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;

  a[href] {
    color: ${({ theme }) => theme.colors.component.link};
  }

  // allow container to expand vertically when printing
  @media print {
    height: initial;
    overflow-y: initial;
  }

  @page {
    margin: 2cm;
  }

  .signature-container {
    padding: 20px 0;
  }

  .signature {
    font-family: ${({ theme }) => theme.fontFamilies.signature};
    font-size: 40px;
    padding: 0 20px;
  }

  // begin: resolve style discrepancies between Layout and SharedBuyLayout
  font-size: 0.9375rem;

  h1,
  h2,
  h3,
  h4,
  h5 {
    margin-block-start: 0.67em;
    margin-block-end: 0.67em;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  p {
    font-family: ${({ theme }) => theme.fontFamilies.roboto} !important;
    line-height: 1.43;
  }

  h1 {
    font-size: 2em;
  }

  h2 {
    font-size: 1.5em;
  }

  h1,
  h2 {
    margin-bottom: 1em;
  }
  h3 {
    margin-bottom: 0.8em;
  }

  p {
    font-size: 0.9375rem;
    margin-block-start: 1em;
    margin-block-end: 1em;
  }
  // end: resolve styled discrepancies
`

export const ProviderFormContainer = styled.div`
  position: relative;

  @media print {
    // add bottom border as visual delimiter when printing
    border-bottom: 1px solid ${({ theme }) => theme.colors.coolGray.cool400};
    padding-bottom: 16px;
    margin-bottom: 16px;
  }
`

export const ProviderFormEditButton = styled.button`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: ${({ theme }) => theme.fontFamilies.roboto};
  font-size: 40px;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  border: 0;
  background: ${({ theme }) => theme.colors.coolGray.cool400}d0;
  color: ${({ theme }) => theme.colors.grayscale.white};
  @media print {
    display: none;
  }
`
